import React, { FC, ReactNode } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { get } from 'lodash';
import { isTrue } from '../../../utils/helper';
import MarkdownRenderer from '../markdown-renderer/MarkdownRenderer';

interface MuiDialogProps {
	open: boolean | null;
	title: string;
	content: string | ReactNode;
	onClose?: () => void;
	onCloseButtonName?: string;
	onCloseButtonVariant?: 'text' | 'outlined' | 'contained';
	onConfirm?: () => void;
	onConfirmButtonName?: string;
	onConfirmButtonVariant?: 'text' | 'outlined' | 'contained';
	hasError?: boolean;
	fullWidth?: boolean;
	maxWidth?: string;
	clickAwayListner?: boolean;
	confirmButtonDisabled?: boolean;
}
const MuiDialog: FC<MuiDialogProps> = (props) => {
	const { content, onCloseButtonVariant = 'outlined', onConfirmButtonVariant = 'contained' } = props;

	const closeDialogOnClickAway = isTrue(get(props, 'clickAwayListner', true)) ? true : false;

	const RenderContent = () => {
		if (typeof content === 'string') {
			return <MarkdownRenderer markdown={content} />;
		} else {
			return <>{content}</>;
		}
	};

	return (
		<>
			<Dialog
				open={get(props, 'open', false)}
				onClose={closeDialogOnClickAway ? get(props, 'onClose') : null}
				sx={{
					textAlign: 'left',
					'& .MuiDialog-paper': {
						backgroundColor: '#eeeeee',
						maxWidth: get(props, 'fullWidth', '55rem'),
						width: get(props, 'fullWidth', '35rem'),
					},
				}}
			>
				<DialogTitle>{get(props, 'title', '')}</DialogTitle>
				<DialogContent>
					<RenderContent />
				</DialogContent>
				<DialogActions>
					{typeof get(props, 'onClose') === 'function' ?
						<Button variant={onCloseButtonVariant} onClick={get(props, 'onClose')}>
							{get(props, 'onCloseButtonName', 'Abbrechen')}
						</Button>
					:	null}
					{typeof get(props, 'onConfirm') === 'function' ?
						!get(props, 'hasError', false) && (
							<Button variant={onConfirmButtonVariant} onClick={get(props, 'onConfirm')} disabled={get(props, 'confirmButtonDisabled', false)}>
								{get(props, 'onConfirmButtonName', 'Bestätigen')}
							</Button>
						)
					:	null}
				</DialogActions>
			</Dialog>
		</>
	);
};

export default MuiDialog;
